import store from "../store";

const generateShareLink = () => {

    console.log("generate share link");

    const { origin } = window.location;
    const activeFloorplan = store.getState()["visualizer"]["activeFloorPlanData"];
    const activeFloorplanSteps = store.getState()["visualizer"]["activeFloorPlanSteps"];

    var shareLink = origin + "/shared/";
    var mydata = {
        floorPlan : activeFloorplan,
        planSteps : activeFloorplanSteps
    }; 
    var myimage = '{}';

    const shareData = {
        specifier:activeFloorplan.exterior,
        sel:activeFloorplan.exteriorSel,
        url:shareLink,
        message:"Check out this design I made using the SeaGate Visualizer!"
    }

    // Avoid calling for actual lizard proxy if its
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortener(shareLink, "SeaGateHomes", JSON.stringify(mydata), myimage).then(function (r) {
            var arr = r.data.shortUrl.split('/');
            shareData["url"] = shareLink + arr[arr.length - 1];
            console.log(shareData);
            resolve(shareData);
            });
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve(shareData);
        });
    }
}

const loadShareLink = (code) => {
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortenerData(code).then(function(r) {
                resolve(r.data)
            })
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve("");
        });
    }
}

export {generateShareLink, loadShareLink}

